import { gql } from "@grandvisionhq/graphql";
import { pickupPoint } from "../../../fragments/operations/fragments/pickup-point.js";
const PICKUP_POINTS_BY_GEO_LOCATION = gql`
  query PickupPointsByGeoLocation($geoLocation: GeoLocationInput!, $shippingDate: Date) {
    pickupPointsByGeoLocation(geoLocation: $geoLocation, shippingDate: $shippingDate) {
      ...PickupPoint
    }
  }
  ${pickupPoint}
`;
export {
  PICKUP_POINTS_BY_GEO_LOCATION
};
//# sourceMappingURL=pickup-points-by-geo-location.js.map
